import { LegalDocumentPage } from "./LegalDocumentPage";

export function CookiePolicyPage() {
  return <LegalDocumentPage docKey="cookies" sectionCount={4} />;
}
